import React from 'react';
import FormLogin from '../components/authentication/FormLogin';

function Login() {
  return (
    <>
      <div className="login">
        <FormLogin />
        </div>
    </>
  );
}

export default Login;